import { Box, Typography } from "@material-ui/core";
import { FC } from "react";

const InputFieldCounter: FC<InputFieldCounterProps> = ({ counter, length, alignSelf = "center" }) => {
  return (
    <Box alignSelf={alignSelf}>
      <Typography variant="body2" color="textSecondary">
        {counter - length}
      </Typography>
    </Box>
  );
};

interface InputFieldCounterProps {
  counter: number;
  length: number;
  alignSelf?: "center" | "flex-end" | "flex-start";
}

export default InputFieldCounter;
